import { Routes } from '@angular/router';
import { GermplasmProgenitorsPopupComponent } from './germplasm-progenitors-modal.component';

export const GERMPLASM_PROGENITORS_ROUTES: Routes = [
    {
        path: 'germplasm-progenitors-dialog/:gid',
        component: GermplasmProgenitorsPopupComponent,
        outlet: 'popup'
    }
];
